export function formatDate(stringDate) {
    var date = new Date(stringDate);
    const month = date.toLocaleString('default', { month: 'long' });
    const day = date.getUTCDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
}
